import { getTopicMealPlanId } from "./topic";

export const redirectToDashboard = async ({ topicSlug, email, name }) => {
  let mealPlanId = await getTopicMealPlanId(topicSlug);
  if (!mealPlanId) mealPlanId = "5ec41399b137fe299f8fb781";
  window.location.replace(
    `https://www.foodimus.com/en/auth/signup?action=try&email=${email}&name=${name}&meal_plan=${mealPlanId}&access_token=jKloPuFv9iKnwdSnEkhvHrc96bOx5MH4`
  );
};
